export enum DataTestId {
  PromotionBanner = "PromotionBanner",
  QuoteGradient = "QuoteGradient",
  QuoteBackground = "QuoteBackground",
  HeroSubmitButton = "HeroSubmitButton",
  HeroSubmitButtonMobile = "HeroSubmitButtonMobile",
  Hero5Button = "Hero5Button",
  Header1GetStartedButton = "Header1GetStartedButton",
  Header1LoginButton = "Header1LoginButton",
  Cta1Button = "Cta1Button",
  Pricing5Container = "Pricing5Container",
  TaxCalculatorContainer = "TaxCalculatorContainer",
  ComparisonChart = "ComparisonChart",
  FooterContainer = "FooterContainer",
  DisclosureContainer = "DisclosureContainer",
  Header1ButtonContainer = "Header1ButtonContainer",
  FAQContainer = "FAQContainer",
  Introduction1Container = "Introduction1Container",
  IntroductionContainer = "IntroductionContainer",
  HeroSubsection4Button = "HeroSubsection4Button",
  Cta4Button = "Cta4Button",
  BillboardContainer = "BillboardContainer",
  Hero18Button = "Hero18Button",
  DesktopMegaNavResources = "DesktopMegaNavResources",
}
